export class BillingCard
{
    private _brand:string;
    private _last4:string;
    private _id:string;


    /**
     * Getter id
     * @return {string}
     */
	public get id(): string {
		return this._id;
	}

    /**
     * Setter id
     * @param {string} value
     */
	public set id(value: string) {
		this._id = value;
	}
    

    /**
     * Getter brand
     * @return {string}
     */
	public get brand(): string {
		return this._brand;
	}

    /**
     * Setter brand
     * @param {string} value
     */
	public set brand(value: string) {
		this._brand = value;
	}

    /**
     * Getter last4
     * @return {string}
     */
	public get last4(): string {
		return this._last4;
	}

    /**
     * Setter last4
     * @param {string} value
     */
	public set last4(value: string) {
		this._last4 = value;
	}
    
}


// WEBPACK FOOTER //
// ./src/app/shared/models/billing-card.ts